<script>
    import Module6 from "./module6.svelte";
    import Humburger from "./humburger.svelte";
    import SwiperCards from "./SwiperCards.svelte";

    let text3List = [
        "Родителям всех детей: Бесплатное санитарно-курортное обслуживание доступно всем детям Москвы с полисом ОМС, независимо от льготной категории.",
        "Детям с ограниченными возможностями: Гайд содержит разделы о реабилитации для таких детей, включая шаблоны заявлений и контакты специалистов.",
        "Родителям детей с хроническими заболеваниями: Информация о том, как отстоять права ребенка на бесплатное лечение.",
    ];

    let textUpperInBottom = [
        "📋 Что внутри?",
        "Пошаговая инструкция: от выбора программы до подачи документов. Все изложено максимально четко и без лишних сложностей. Информация о доступных программах лечения для детей, независимо от льгот или медицинских показаний. Готовые шаблоны и ссылки, чтобы вам не пришлось искать информацию самим.",
        "🎯 Кому подойдет?",
        "Этот гайд особенно полезен, если вы живете и зарегистрированы в Москве, но многое из него будет актуально и для других регионов.",
        "💡 Почему это удобно?",
        "Мы описали процесс так, чтобы вам не пришлось долго разбираться. Все шаги понятны, а документы заполняются быстро благодаря детальным инструкциям.",
    ];

    let slides = [
        {
            id: 1,
            image: "/photo/IMG_sanatorium_1.jpg",
        },
        {
            id: 2,
            image: "/photo/IMG_sanatorium_2.jpg",
        },
        {
            id: 3,
            image: "/photo/IMG_sanatorium_3.jpg",
        },
        {
            id: 4,
            image: "/photo/IMG_sanatorium_4.jpg",
        },
        {
            if: 5,
            image: "/photo/IMG_sanatorium_5.jpg",
        },
    ];

    let price = "2990";
</script>

<dev class="moduleSanatoriums">
    <div class="blockColor">
        <div class="arrow">
            <a href="/" class="arrow-link">
                <span class="arrow-icon">&#8594;</span>
            </a>
        </div>
    </div>
    <div class="bodyBlock">
        <p class="text1">
            Воспользуйтесь правом на бесплатное санаторное лечение!
        </p>
        <hr class="hr" />
        <SwiperCards {slides} />
        <p class="text5">
            Дорожная карта по санаториям: помогаем разобраться в сложностях
            лечения для детей.
        </p>
        <p class="text6">
            Если вы хотите отправить ребенка в санаторий, но не знаете, с чего
            начать, этот гайд для вас. Мы собрали все важные шаги и сделали их
            простыми и понятными.
        </p>

        {#each textUpperInBottom as text}
            {#if text.length < 50}
                <p class="textUpperInBottom">{text}</p>
            {:else if text.length > 50}
                <p class="textLowerInBottom">{text}</p>
            {/if}
        {/each}

        <p class="text6">
            Теперь отправить ребенка в санаторий — это не проблема. Вы точно
            справитесь!
        </p>
        <div class="blok-buy-button">
            <a class="buy-button" href="\formBuy">
                Купить
                <span class="cart-icon"
                    ><img
                        src="photo/IMG_bag.jpg"
                        class="ico"
                        alt="ico_bag"
                    /></span
                >
                {price}₽
            </a>
        </div>
        <p class="text2">Кому пригодится?</p>
        {#each text3List as text3}
            <p class="text3">• {text3}</p>
        {/each}
        <p class="text4">
            Вы поймете принцип работы системы и будете более уверенны в своих
            дейтствиях по отстаиванию прав своего ребенка!
        </p>
    </div>
</dev>

<Module6 />
<Humburger />

<style>
    .blockColor {
        width: 100%;
        height: 60px;
        background-color: #4f7942;
        margin-bottom: 30px;
    }

    .bodyBlock {
        /* margin-top: 40px; */
        margin: 0 auto;
        margin-bottom: 40px;
    }

    .text1,
    .text5 {
        margin: 0 auto;
        color: #4f7942;
        text-align: center;
        /* margin-bottom: 35px; */
    }
    .text2,
    .text3,
    .text4,
    .text6,
    .textLowerInBottom,
    .textUpperInBottom {
        color: #4f7942;
        text-align: left;
    }
    .text2,
    .text4,
    .text6,
    .textUpperInBottom {
        margin-bottom: 20px;
    }
    .text5 {
        margin-bottom: 22px;
        text-decoration: underline 2px;
    }

    .arrow {
        margin: 0 auto;
        height: 60px;
        display: flex; /* Добавляем flexbox */
        flex-direction: column; /* Выравниваем по вертикали */
        justify-content: center;
    }
    .arrow-link {
        display: inline-block;
        position: relative;
        color: #eaf4e5;
        text-decoration: none;
    }

    .arrow-icon {
        position: absolute;
        font-size: 24px;
        transform: translateY(-50%) rotate(180deg);
    }

    .hr {
        border-top: 2px solid #4f7942;
        /* margin-top: 20px; */
        margin-bottom: 20px;
    }

    .blok-buy-button {
        margin: 0 auto;
        text-align: center;
    }
    .buy-button {
        display: inline-flex;
        align-items: center;
        background-color: #4f7942; /* Пример цвета */
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        text-decoration: none;
    }

    /* .cart-icon {
        margin-right: 10px;
    } */

    .ico {
        width: 27px;
        height: 27px;
    }

    @media (min-width: 1280px) {
        .bodyBlock {
            max-width: 50%;
        }
        .arrow {
            max-width: 50%;
            height: 60px;
        }
        .text1,
        .text5 {
            font-size: 27px; /*Размер шрифта*/
            font-weight: 600; /*Толщина*/
        }
        .text2,
        .text4,
        .text6,
        .textUpperInBottom {
            font-size: 25px; /*Размер шрифта*/
            font-weight: 400;
        }
        .text3,
        .textLowerInBottom {
            font-size: 20px; /*Размер шрифта*/
            font-weight: 200;
        }
        .blok-buy-button {
            max-width: 50%;
        }
        .buy-button {
            padding: 10px 75px;
            font-size: 20px;
        }
    }
    @media (max-width: 480px) {
        .bodyBlock {
            max-width: 90%;
        }
        .arrow {
            max-width: 90%;
        }
        .text1,
        .text5 {
            font-size: 25px; /*Размер шрифта*/
            font-weight: 600; /*Толщина*/
        }
        .text2,
        .text4,
        .text6,
        .textUpperInBottom {
            font-size: 20px; /*Размер шрифта*/
            font-weight: 400;
        }
        .text3,
        .textLowerInBottom {
            font-size: 15px; /*Размер шрифта*/
            font-weight: 200;
        }
        .blok-buy-button {
            max-width: 90%;
        }
        .buy-button {
            padding: 5px 50px;
            font-size: 20px;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) {
        /*Телефон горизонталь*/
        .bodyBlock {
            max-width: 90%;
        }
        .arrow {
            max-width: 90%;
        }
        .text1,
        .text5 {
            font-size: 25px; /*Размер шрифта*/
            font-weight: 600; /*Толщина*/
        }
        .text2,
        .text4,
        .text6,
        .textUpperInBottom {
            font-size: 20px; /*Размер шрифта*/
            font-weight: 400;
        }
        .text3,
        .textLowerInBottom {
            font-size: 15px; /*Размер шрифта*/
            font-weight: 200;
        }
        .blok-buy-button {
            max-width: 90%;
        }
        .buy-button {
            padding: 5px 50px;
            font-size: 20px;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) {
        .bodyBlock {
            max-width: 90%;
        }
        .arrow {
            max-width: 90%;
        }
        .text1,
        .text5 {
            font-size: 25px; /*Размер шрифта*/
            font-weight: 600; /*Толщина*/
        }
        .text2,
        .text4,
        .text6,
        .textUpperInBottom {
            font-size: 20px; /*Размер шрифта*/
            font-weight: 400;
        }
        .text3,
        .textLowerInBottom {
            font-size: 15px; /*Размер шрифта*/
            font-weight: 200;
        }
        .blok-buy-button {
            max-width: 90%;
        }
        .buy-button {
            padding: 5px 50px;
            font-size: 20px;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
        .bodyBlock {
            max-width: 90%;
        }
        .arrow {
            max-width: 90%;
        }
        .text1,
        .text5 {
            font-size: 25px; /*Размер шрифта*/
            font-weight: 600; /*Толщина*/
        }
        .text2,
        .text4,
        .text6,
        .textUpperInBottom {
            font-size: 20px; /*Размер шрифта*/
            font-weight: 400;
        }
        .text3,
        .textLowerInBottom {
            font-size: 15px; /*Размер шрифта*/
            font-weight: 200;
        }
        .blok-buy-button {
            max-width: 90%;
        }
        .buy-button {
            padding: 5px 50px;
            font-size: 20px;
        }
    }
</style>
